import React from 'react';
import useStyles from './ParcelBanner.styles.ts';
import Box from '@mui/material/Box';
import { IconButton, useTheme } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { Typo } from 'components/primitive';
import { Nullable } from 'interfaces/Nullable.ts';

type ParcelBannerProps = {
  parcelID: Nullable<string>;
  isFetchingParcel: boolean;
  readOnly: boolean;
  permissions: { UPDATE: boolean };
  onEditModalParcelID: () => void;
};

const ParcelBanner: React.FC<ParcelBannerProps> = ({
  parcelID,
  isFetchingParcel,
  readOnly,
  permissions,
  onEditModalParcelID,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  if (!parcelID) return null;

  return (
    <Box sx={classes.parcelContainer}>
      <Typo sx={classes.parcelContainer.text} style={{ textTransform: 'uppercase' }}>
        PARCEL INFO
      </Typo>
      <Box sx={classes.parcelContainer.wrapper}>
        <Typo sx={classes.parcelContainer.text} role='status'>
          {isFetchingParcel
            ? 'Looking up parcel. Save is unavailable until this completes.'
            : `Parcel ${parcelID}`}
        </Typo>
        {!readOnly && permissions.UPDATE && (
          <IconButton aria-label='Edit Parcel ID' onClick={onEditModalParcelID}>
            <EditNoteIcon fontSize={'small'} sx={{ color: theme.palette.primary.main }} />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default ParcelBanner;
